import {Loader} from '@hconnect/uikit'
import {Box} from '@mui/material'
import {useMemo, useState} from 'react'

import {useGetAssetConfig} from '../../api/queries'
import {AssetConfigurationDto, HeatZone} from '../../types'

import {HeatZonesForm} from './HeatZonesForm'
import {HeatZonesView} from './HeatZonesView'

type HeatZonesProps = {
  assetId: string
}

const DEFAULT_START = 0

export const HeatZonesWrapper = ({assetId}: HeatZonesProps) => {
  const {isLoading: isConfigLoading, data: assetConfig} = useGetAssetConfig(assetId)

  const kilnLength = Number(assetConfig?.payload.configuration.dimensions.length)

  if (isConfigLoading) {
    return <Loader color="grey" height="60vh" />
  }

  if (!assetConfig || !kilnLength || isNaN(kilnLength)) {
    // HCP-97627 Add redirect to the kiln config page if kiln length is not found
    return (
      <Box>
        <p>No kiln length found</p>
      </Box>
    )
  }

  return <HeatZones kilnLength={kilnLength} assetConfig={assetConfig} />
}

const HeatZones = ({
  kilnLength,
  assetConfig
}: {
  kilnLength: number
  assetConfig: AssetConfigurationDto
}) => {
  const defaultHeatZones = useMemo(
    () => [
      {
        name: '',
        start: DEFAULT_START,
        end: kilnLength
      }
    ],
    [kilnLength]
  )

  const defaultZones = useMemo(() => {
    if (assetConfig?.payload.layout.heatZones && assetConfig?.payload.layout.heatZones.length > 0) {
      return assetConfig.payload.layout.heatZones
    }

    return defaultHeatZones
  }, [assetConfig.payload.layout.heatZones, defaultHeatZones])

  const [heatZones, setHeatZones] = useState<HeatZone[]>(defaultZones)

  return (
    <Box>
      <Box mb={4}>
        <HeatZonesView heatZones={heatZones} kilnLength={kilnLength} />
      </Box>
      <HeatZonesForm
        heatZones={heatZones}
        kilnLength={kilnLength}
        setHeatZones={setHeatZones}
        assetConfig={assetConfig}
      />
    </Box>
  )
}
